export default __webpack_public_path__ + "bfeb427bc1074a5098125d48fc522d5f.png";